/*
 * @Author: huangzq
 * @Date: 2019-12-17 17:17:38
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-08-06 09:25:48
 * @Desc: 选择文章类型-已手动保持同步
*/
<template>
  <div class="select">
    <div class="content">
      <div class="title">
        <h3>请选择写文章的方式</h3>
        <i
          class="icon iconfont icon-mk-guanbi"
          @click="cancel"
        ></i>
      </div>
      <!-- <div class="tips">
        <i class="el-icon-info"></i>
        <span>{{ tips[activeName] }}</span>
      </div> -->
      <tips-info :tips="tips[activeName]" />
      <div class="radio-group">
        <ul>
          <li
            v-for="(item,index) in items"
            :key="index"
          >
            <label :for="item.id">
              <input
                :id="item.id"
                v-model="activeName"
                type="radio"
                :value="item.value"
              />
              <span :class="item.value === activeName ? 'active' : ''">{{ item.label }}</span>
            </label>
          </li>
        </ul>
      </div>
      <div
        v-if="infos[activeName]"
        class="info"
      >
        <div class="info-con">
          <ds-iconfont icon-class="icon-ds-shuomingtishi"></ds-iconfont>
          <span>{{ infos[activeName] }}</span>
          <ul>
            <li>1、原创文章和微信转载可以记录用户更多的访问行为（浏览，停留，阅读完成等）</li>
            <li>2、用户在阅读原创文章和微信转载文章时，可以联系到分享文章的对应销售</li>
            <li>3、任意链接转载的文章，只能记录到用户的访问（何时查看了该文章）</li>
          </ul>
        </div>
      </div>
      <div class="btn-group">
        <mk-button-biz
          width="64px"
          font-size="13px"
          @click="cancel"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="64px"
          font-size="13px"
          @click="confirm"
        >
          确认
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
import tipsInfo from '@components/tips-info'
export default {
  components: {
    tipsInfo
  },
  data () {
    return {
      items: [
        {
          value: 0,
          label: '原创文章',
          id: 'select-type-f'
        },
        {
          value: 1,
          label: '转载微信文章',
          id: 'select-type-s'
        },
        {
          value: 2,
          label: '转载任意链接文章',
          id: 'select-type-t'
        }
      ],
      activeName: 0,
      tips: ['原创一篇文章。', '转载微信公众号的文章。', '转载任意外部链接的文章或内容。'],
      infos: ['', '和转载任意链接文章有什么不同？', '和转载微信文章有什么不同？']
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm (e) {
      switch (this.activeName) {
        case 0:
          this.$router.push({
            path: '/marketing-content/marketing-data/original-article'
          })
          break
        case 1:
          this.$router.push({
            path: '/marketing-content/marketing-data/reprint-article'
          })
          break
        case 2:
          this.$router.push({
            path: '/marketing-content/marketing-data/reprint-all-article'
          })
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  input[type='radio'] {
    -webkit-appearance: none;
    vertical-align: middle;
    background: #fff;
    border: #d1d1d1 solid 1px;
    border-radius: 100%;
    width: 16px;
    height: 16px;
    position: relative;
    // border-color: #009cff;
    box-sizing: border-box;
    flex-shrink: 0;
    cursor: pointer;
  }

  input[type='radio']:checked {
    border-color: #009cff;
  }

  input[type='radio']:focus {
    outline: none;
  }

  input[type='radio']:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #009cff;
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    width: 407px;
    // box-shadow: 0 4px 12px 0 #e8e8e8;
    border-radius: 4px;

    .title {
      height: 54px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 -1px 0 0 #e8e8e8 inset;

      h3 {
        font-size: 14px;
        color: #262626;
        margin-left: 20px;
      }

      .icon {
        font-size: 14px;
        color: #bfbfbf;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    .tips {
      width: calc(100% - 40px);
      margin: 0 auto;
      height: 40px;
      margin-top: 10px;
      margin-bottom: 16px;
      box-sizing: border-box;
      line-height: 40px;
      background: rgba(239, 250, 247, 1);
      border: 1px solid rgba(145, 213, 255, 1);
      display: flex;

      .el-icon-info {
        color: #009cff;
        margin: 0 8px 0 16px;
        font-size: 14px;
        line-height: 40px;
      }

      span {
        font-size: 12px;
        color: #595959;
      }
    }

    .info {
      width: calc(100% - 32px);
      margin: 0 auto;
      cursor: pointer;
      font-size: 12px;
      color: #888;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 12px;

      .info-con {
        display: inline-flex;
        align-items: center;

        ul {
          width: 100%;
          height: 156px;
          background: #fff;
          box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
          color: #888;
          position: absolute;
          top: -16px;
          left: 0;
          display: none;
          border-radius: 4px 4px 0 0;

          &::after {
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 5px solid #fff;
            content: "";
            position: absolute;
            bottom: -5px;
            right: 32px;
            width: 0;
          }

          li {
            width: calc(100% - 36px);
            margin: 0 auto;
            line-height: 18px;
            margin-top: 12px;
            font-size: 13px;
          }
        }

        i {
          font-size: 14px;
          line-height: 14px;
          margin: -1px 4px 0 0;
        }

        &:hover {
          color: #009cff;

          ul {
            display: block;
          }
        }
      }
    }

    .radio-group {
      width: calc(100% - 40px);
      margin: 0 auto;
      margin-bottom: 24px;

      ul {
        display: flex;
        justify-content: space-between;

        li {
          label {
            cursor: pointer;

            span {
              margin-left: 8px;
              color: #595959;
              font-size: 14px;
            }

            span.active {
              color: #009cff;
            }
          }
        }
      }
    }

    .btn-group {
      height: 54px;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
    }
  }
}
</style>
